import WelcomeContainer from '../../wrappers/WelcomeContainer'
import FormInput from '../../../ui-kit/components/templates/FormInput'
import {Link} from 'react-router-dom'
import PasswordInput from '../../molecules/inputs/PasswordInput'

const LoginForm = () => {
  return (
    <WelcomeContainer title="Bienvenido de nuevo">
      <FormInput type="email" label="Correo electrónico" placeholder="juan@gmail.com" />
      <div className="input-password">
        <PasswordInput />
        <Link to="">¿Olvidaste tu contraseña?</Link>
      </div>
      <button className="button">Inicia sesión</button>
    </WelcomeContainer>
  )
}

export default LoginForm
